export var SDK_VERSION = '6.1.0';
//# sourceMappingURL=version.js.map